export const SET_IMPERSONATION_PENDING = 'SET_IMPERSONATION_PENDING';
export const SET_IMPERSONATION_ERROR = 'SET_IMPERSONATION_ERROR';
export const SET_IMPERSONATION_SUCCESS = 'SET_IMPERSONATIONSUCCESS';
export const SET_IMPERSONATION_FORM_INITIAL_STATE =
  'SET_IMPERSONATION_FORM_INITIAL_STATE';

export const OPEN_SET_IMPERSONATION_MODAL = 'OPEN_SET_IMPERSONATION_MODAL';
export const CLOSE_SET_IMPERSONATION_MODAL = 'CLOSE_SET_IMPERSONATION_MODAL';
